import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label:
      "If you're on multiple treatments with us, please share which one you're having issues with.",
    field: 'civTreatment',
    type: 'info',
    required: true,
    answer: {
      type: 'text',
      name: 'treatment',
      required: true,
      placeholder: 'Please describe'
    }
  },
  {
    label: 'Is this treatment working the way you expected it to?',
    field: 'civWorking',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yesWorking',
          value: 'Yes, working well.'
        },
        {
          key: 'notWorking',
          value: 'No, not meeting my expectations. ',
          answer: {
            type: 'list',
            items: [
              {
                label: '',
                type: 'text',
                name: 'describeNotWorking',
                required: true,
                placeholder: 'Please describe'
              }
            ]
          }
        }
      ]
    }
  },
  {
    label: 'Have you experienced any side effects from the treatment?',
    field: 'civSideEffect',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yesSideEffect',
          value: 'I have had side effects.',
          answer: {
            type: 'list',
            items: [
              {
                label: '',
                type: 'text',
                name: 'describeSideEffect',
                required: true,
                placeholder: 'Please describe'
              }
            ]
          }
        },
        {
          key: 'noSideEffect',
          value: 'No side effects.'
        }
      ]
    }
  },

  {
    label:
      'Do you want to update your treatment? Let us know if you’d like to make any changes to your treatment.',
    field: 'civUpdateTreatment',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yesChangeTreatment',
          value:
            'I’d like to talk to someone about changing or adjusting my treatment.'
        },
        {
          key: 'noChangeTreatment',
          value: 'I don’t want to make any changes at this time.'
        }
      ]
    }
  },

  {
    //
    // Education Slide
    field: 'civEducationl1',
    type: 'info',
    educationalSlide:
      'Thank you for completing this form ! If there is anything else we can do for you, hop into the myHealth Medical Chat.' +
      '\n\n' +
      'If you asked to adjust your treatment - go ahead hit the Finish button and you will be redirected to the myHealth Medical Chat and share the issues you’re experiencing. Our team will review and get back to you on next steps.',
    label: '',
    answer: {}
  }
];
export default questionsModels;
